module.exports = __webpack_public_path__ + "static/img/Mark-Geyer.f8d21f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mark-Geyer.jpg
// module id = 5vZh
// module chunks = 0